module.exports = __webpack_public_path__ + "static/img/a085.39dbdbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a085.jpg
// module id = iYAt
// module chunks = 0